var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFields = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h7.519v3.2H0zm10.74 0h7.52v3.2h-7.52zm10.741 0H29v3.2h-7.519zM0 5.333h7.519v24.534L3.855 32 0 29.867zm10.74 0h7.52v24.534L14.568 32l-3.828-2.133zm10.741 0H29v24.534L25.211 32l-3.73-2.133z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFields);
export default ForwardRef;